<template>
  <div>
    <template>
      <div class="modal is-active" v-if="showModal">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Delete Notification</p>
            <button
              class="icon is-right"
              @click.prevent="toggleModal()"
              ref="closeIcon"
            >
              <font-awesome-icon :icon="['fal', 'times']" title="Close" />
            </button>
          </header>
          <section class="modal-card-body">
            <div class="modal-body">
              You cannot recover deleted notifications. <br>
              Are you sure you want to delete this notification?
            </div>
            <div class="update-box">
              <button
                  class="button button-link has-underline"
                  @click.prevent="toggleModal()">
                Cancel
              </button>
              <button
                class="button is-primary"
                @click="deleteSystemNotification()">
                  Delete Notification
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>

  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Notifications
          </div>
        </template>
      </EsHeader>
    </div>
    <es-loader v-if="loading" style="margin: 5rem"/>
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="0"
      style="padding: 5rem"
    />
    <div v-else class="content">
      <es-form style="padding: 1.15rem 0rem">
        <template #es-form-header>
          <div class="header-container">
            <div v-if="editCurrentPanel">
              <th>
                <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                  Edit System Notification Details
              </th>
            </div>
            <div v-else>
              <th>
                <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                  System Notification Details
              </th>
            </div>
            <div class="icons" v-if="!editCurrentPanel && !loading && !loadingError">
              <button class="button button-link"
                  @click="editPanel()" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
                <font-awesome-icon :icon="['far', 'edit']" size="lg" title="Edit" />
              </button>
              <button class="button button-link"
                  @click="toggleModal()" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')"
                  ref="linkDelete">
                <font-awesome-icon :icon="['far', 'trash-alt']" size="lg" title="Delete" />
              </button>
              <button class="button button-link"
                  @click="goBackToNotifications()">
                <font-awesome-icon :icon="['far', 'angle-double-left']" size="lg" title="Go Back" />
              </button>
            </div>
          </div>
        </template>
        <template #es-form>
          <table>
            <tbody>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Job Type
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div>
                      {{ thisSchedule.job.jobType }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Job Trigger Type
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div>
                      {{ thisSchedule.job.jobTriggerType }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Send To
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div class="">
                      {{ scheduleData.notification.sendTo }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Additional Email (optional)
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control" v-if="editCurrentPanel">
                    <input
                      class="input has-text-grey is-italic"
                      type="text"
                      :readonly="!editCurrentPanel"
                      :class="{ 'is-static': !editCurrentPanel }"
                      maxlength="250"
                      v-model="additionalEmail"
                      placeholder="sample@email.com"
                      aria-label="Additional Email (optional)"
                    >
                  </div>
                  <div v-else class="is-italic has-text-grey">
                    {{ thisSchedule.notification.additionalEmail || 'N/A' }}
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Email Template
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div v-if="editCurrentPanel && changeFile"
                      :class="{ 'no-temp': !editCurrentPanel }"
                      class="
                        is-flex
                        flex-direction--column
                        flex-justify--start
                        file
                        has-name
                        is-right
                        is-fullwidth
                      "
                    >
                      <es-email-template-upload-input
                        input-id="id"
                        input-ref="inputFile"
                        :has-error-file="hasErrorFile"
                        @validFileExtensions="setErrors($event)"
                        :selected-files="files"
                      />
                      <div v-if="hasErrorFile" class="help is-danger">
                        {{ errorMsgFile }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="is-flex flex-align--center">
                        <div>{{ thisSchedule.notification.template }}</div>
                        <button
                          v-if="editCurrentPanel"
                          @click="changeFile = true"
                          class="button button-link has-underline"
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Frequency Type
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div>
                      {{ thisSchedule.schedule.frequencyType }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Severity
                </th>
                <td>
                  <div class="control">
                    <div
                      class="buttons has-addons"
                      v-if="editCurrentPanel"
                    >
                      <button
                        class="button button--form"
                        v-for="(option, index) in severityOptions"
                        :key="index"
                        @click="severityData = option.description"
                        :class="{ 'is-active': severityData === option.description }"
                      >
                        {{ option.description }}
                      </button>
                    </div>
                    <input
                      v-else
                      class="input no-padding"
                      :class="{ 'is-static': !editCurrentPanel }"
                      type="text"
                      :value="thisSchedule.notification.severity"
                      :readonly="!editCurrentPanel"
                      aria-label="Severity"
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
      <div v-if="editCurrentPanel"
        class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 2rem; padding-bottom: 2rem"
      >
        <button
          class="button button-link has-underline"
          @click.prevent="cancelPanel()"
          style="margin-right: 1rem"
        >
          Cancel
        </button>
        <button
          class="button is-primary"
          @click.prevent="checkRequiredFields()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faEdit,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { faCog } from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsEmailTemplateUploadInput from '@/components/EsEmailTemplateUploadInput.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

library.add(
  faAngleDoubleLeft,
  faEdit,
  faCog,
  faTrashAlt,
);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
    AccessibilityUtils,
  ],
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
    EsEmailTemplateUploadInput,
  },
  data() {
    return this.initialData();
  },
  props: {
    scheduleData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      activeModules: 'appModules/activeModules',
      allModules: 'appModules/getAllModules',
      properties: 'propertiesModule/properties',
    }),
    formDataBody() {
      const formData = new FormData();
      formData.append('jobId', this.scheduleData.job.id);
      formData.append('jobType', this.jobTypeSystem);
      formData.append('jobLevel', '');
      formData.append('jobTriggerType', this.scheduleData.job.jobTriggerType);

      formData.append('notificationId', this.scheduleData.notification.id);
      formData.append('severity', this.severityData);
      formData.append('sendTo', 'State Super Users');
      formData.append('additionalEmail', this.additionalEmail);

      if (this.files[0] && this.files[0].name) {
        const selectedTemplateName = this.files[0].name;
        formData.append('template', selectedTemplateName);
        formData.append('templateContent', this.files[0]);
      } else {
        formData.append('template', this.scheduleData.notification.template);
      }
      formData.append('frequencyType', 'Immediate');

      return formData;
    },
  },
  created() {
    this.onLoad();
    this.additionalEmail = this.scheduleData.notification.additionalEmail || '';
    this.severityOptions = [
      {
        description: 'High',
      },
      {
        description: 'Medium',
      },
      {
        description: 'Low',
      },
    ];
  },
  watch: {
    additionalEmail(newVal) {
      this.scheduleData.notification.additionalEmail = newVal;
    },
  },
  methods: {
    initialData() {
      return {
        showModal: false,
        loading: false,
        loadingError: false,
        editCurrentPanel: false,
        hasErrorFile: false,
        errorMsgFile: null,
        changeFile: false,
        thisSchedule: {},
        files: [],
        sendToType: this.scheduleData.notification.sendTo,
        severityData: this.scheduleData.notification.severity,
        jobTypeSystem: this.scheduleData.job.jobType,
      };
    },
    getSchedules() {
      if ((this.activeModule && this.activeModule.name) === 'personId') {
        return axios.get('schedules/list/pid');
      // eslint-disable-next-line no-else-return
      } else if ((this.activeModule && this.activeModule.name) === 'directMatch') {
        return axios.get('schedules/list/dm');
      } else if ((this.activeModule && this.activeModule.name) === 'locationID') {
        return axios.get('schedules/list/loc');
      } else {
        return axios.get('schedules');
      }
    },
    getThisSchedule() {
      return axios.get(`schedules/${this.scheduleData.schedule.id}`);
    },
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;
        const responses = await Promise.all([
          this.getThisSchedule(),
        ]);
        this.thisSchedule = responses[0].data;
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    checkRequiredFields() {
      if (!this.scheduleData.notification.template && !this.files.length) {
        this.hasErrorFile = true;
        this.errorMsgFile = 'No file chosen. A File is required.';
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      } else if (this.files.length) {
        if (!this.hasErrorFile) {
          this.updatePanel();
        } else {
          this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
        }
      } else {
        this.updatePanel();
      }
    },
    async updatePanel() {
      try {
        this.loading = true;
        await axios({
          method: 'put',
          url: `schedules/${this.scheduleData.schedule.id}`,
          data: this.formDataBody,
        });
        this.goBackToNotifications();
        this.showNotification('success', ['The System Notification has been updated successfully.']);
      } catch (e) {
        this.showNotification('danger', ['The Notification could not be updated.']);
      } finally {
        this.loading = false;
      }
    },
    setErrors(value) {
      if (!value) {
        this.hasErrorFile = true;
        this.errorMsgFile = 'File extension is invalid. Valid extensions are \'.txt\' or \'.csv\' or \'.TXT\' or \'.CSV\'';
      } else {
        this.clearErrors();
      }
    },
    clearErrors() {
      this.hideNotification();
      this.hasErrorFile = false;
      this.errorMsgFile = null;
    },
    async deleteSystemNotification() {
      this.loading = true;
      this.loadingError = false;
      try {
        await axios.delete(`schedules/${this.scheduleData.schedule.id}`);
        this.goBackToNotifications();
        this.showNotification('success', ['The Schedule has been deleted.']);
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.$nextTick(() => {
        const modalOpenFocus = this.$refs.closeIcon;
        const modalCloseFocus = this.$refs.linkDelete;
        this.getFocusModal(modalOpenFocus, modalCloseFocus);
      });
    },
    cancelPanel() {
      this.editCurrentPanel = !this.editCurrentPanel;
      this.changeFile = false;
      this.hasErrorFile = false;
      this.errorMsgFile = null;
      this.hideNotification();
    },
    goBackToNotifications() {
      this.$emit('viewSystemNotificationDetails');
    },
    editPanel() {
      this.hideNotification();
      this.editCurrentPanel = !this.editCurrentPanel;
    },
  },
};
</script>

<style lang="sass" scoped>
  table th
    vertical-align: middle
  table td
    vertical-align: middle
    padding-left: 0
    &:first-child
      width: 30%
  .last-child
      padding-bottom: 2rem
  .header
    display: flex
    align-items: center
  .no-border
    border: 0
  .icons
    margin-left: auto
    width: 100px
    display: flex
    justify-content: space-around
    padding-right: 1rem
  .no-temp
    pointer-events: none
  .no-padding
    padding-left: 0 !important
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
    color: #444
    font-weight: 700
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
</style>
